// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import UploadRedebitsFileRequestModel from '../../model/upload-redebits-file-request-model';
import UploadRedebitsFileRequestDTO from '../dto/upload-redebits-file-request-dto';
import dtoSchema from '../schemas/upload-redebits-file-request-schema';

export default abstract class UploadRedebitsFileRequestModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<UploadRedebitsFileRequestDTO>) {
    super();
    if (data) {
      this.file = data.file;
    }
  }
  /**
  * @type {binary}
  */
  file?: File;

  static toModel(dto: DeepPartial<UploadRedebitsFileRequestDTO>): UploadRedebitsFileRequestModel;
  static toModel(dto: DeepPartial<UploadRedebitsFileRequestDTO> | undefined | null): UploadRedebitsFileRequestModel | undefined;
  static toModel(dto: DeepPartial<UploadRedebitsFileRequestDTO> | undefined | null): UploadRedebitsFileRequestModel | undefined {
    return dto ? new UploadRedebitsFileRequestModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<UploadRedebitsFileRequestModel> | UploadRedebitsFileRequestModel): UploadRedebitsFileRequestDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      file: unwrapped.file,
    } as UploadRedebitsFileRequestDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for UploadRedebitsFileRequestModel, can not map to UploadRedebitsFileRequestDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
